import { Directive, ElementRef, Renderer2, effect, inject, input } from '@angular/core';

@Directive({
  selector: '[nrEllipsis]',
})
export class EllipsisDirective {
  private static readonly DEFAULT_LINES = 1;
  private static readonly DEFAULT_STYLES = {
    'display': '-webkit-box',
    'overflow': 'hidden',
    'text-overflow': 'ellipsis',
    '-webkit-box-orient': 'vertical',
    'overflow-wrap': 'anywhere',
    '-webkit-line-clamp': EllipsisDirective.DEFAULT_LINES,
  };

  private readonly el = inject(ElementRef);
  private readonly renderer = inject(Renderer2);
  readonly nrEllipsis = input<string | number>(EllipsisDirective.DEFAULT_LINES);

  constructor() {
    effect(() => {
      this.renderer.setStyle(this.el.nativeElement, '-webkit-line-clamp', this.calculateLines());
    });
    Object.entries(EllipsisDirective.DEFAULT_STYLES).forEach(([property, value]) => {
      this.renderer.setStyle(this.el.nativeElement, property, value);
    });
  }

  private calculateLines(): number {
    const inputLines = this.nrEllipsis();
    if (typeof inputLines === 'number') return Math.max(inputLines, 1);
    else if (typeof inputLines === 'string') {
      const parsedNumber = parseInt(inputLines, 10);
      return isNaN(parsedNumber) ? 1 : parsedNumber;
    }
    return 1;
  }
}
